import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import MuiDivider from '@mui/material/Divider';
import MuiBox from '@mui/material/Box';
import MuiTypography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useEffect, useCallback, useMemo } from 'react';
import { components } from 'react-select';
import { useDropdown } from '../context/DropdownProvider.js';

const Createable = styled(MuiBox) `
  ${({ size, theme }) => `
    display: flex;
    cursor: pointer;
    padding: ${theme.spacing(size === 'large' ? 2.5 : 0.5, 4, size === 'large' ? 2.5 : 0.5, 3)};
    color: ${theme.palette.primary.main};
    &:hover {
      color: ${theme.palette.primary.light};
      background-color: ${theme.palette.N30.main};
    }
    white-space: nowrap;
    border-radius:0 0 4px 4px;
    ${size === 'large' && `height: 36px`};
  `}
`;
const Text = styled(MuiTypography) `
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  white-space: nowrap;
  flex: 1;
`;
const Divider = styled(MuiDivider) `
  margin: ${({ theme }) => theme.spacing(0, 0, 1, 0)};
`;
const Menu = (_a) => {
    var { children, options, selectProps, innerProps } = _a, rest = __rest(_a, ["children", "options", "selectProps", "innerProps"]);
    const { onCreate, size, handleShadow, getCreateLabel, 'data-testid': testId, footer } = useDropdown();
    const { inputValue } = selectProps;
    const creatable = !!onCreate;
    useEffect(() => {
        handleShadow === null || handleShadow === void 0 ? void 0 : handleShadow();
    }, [handleShadow, inputValue]);
    const createableOnClick = useCallback(() => {
        onCreate === null || onCreate === void 0 ? void 0 : onCreate(inputValue);
    }, [inputValue, onCreate]);
    const createableLabel = useMemo(() => {
        if (typeof getCreateLabel === 'function') {
            return getCreateLabel(inputValue);
        }
        return getCreateLabel;
    }, [getCreateLabel, inputValue]);
    const menuProps = useMemo(() => (Object.assign(Object.assign({}, innerProps), { 'data-testid': `${testId}-menu` })), [innerProps, testId]);
    return (jsx(components.Menu, Object.assign({ options: options, selectProps: selectProps, innerProps: menuProps }, rest, { children: jsxs(Fragment, { children: [children, creatable && jsx(Divider, {}), creatable && (jsx(Createable, Object.assign({ size: size, onClick: createableOnClick, "data-testid": "create-option" }, { children: jsx(Text, Object.assign({ variant: size === 'large' ? 'subtitle1' : 'body1' }, { children: createableLabel })) }))), footer || null] }) })));
};

export { Menu as default };
//# sourceMappingURL=Menu.js.map
